import { Navigate } from "react-router-dom";
import { useAppSelector } from "src/redux/hooks";
import { getAuthState } from "src/redux/slices/authSlice";

interface GuestGuardProps {
  children: React.ReactNode;
}

const GuestGuard: React.FC<GuestGuardProps> = ({ children }) => {
  const { isAuthenticated } = useAppSelector(getAuthState);

  if (isAuthenticated) {
    return <Navigate to="/Dashboard" />;
  }

  return <>{children}</>;
};

export default GuestGuard;
